module.exports = __webpack_public_path__ + "static/img/cranmer.6a50873.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/scoiatael/cranmer.png
// module id = nS+L
// module chunks = 0